var _defs, _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencilSize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #a6a6a6;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "30.47 9.05 38.95 17.53 18.52 37.96 10.04 29.47 30.47 9.05 30.47 9.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41.06,15.4l-8.47-8.47c2.34-2.23,6.06-2.19,8.36.11,2.3,2.31,2.34,6.01.11,8.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "7.92 31.59 6 42 16.41 40.08 7.92 31.59"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8.56,6.44l10.14,10.14-2.12,2.12L6.44,8.56c-.59-.59-.59-1.54,0-2.12.58-.59,1.53-.59,2.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41.55,41.55c-.29.29-.68.44-1.06.44s-.77-.15-1.06-.44l-10.13-10.13,2.12-2.12,10.13,10.13c.59.58.59,1.53,0,2.12Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.5,
    y1: 7.5,
    x2: 17.37,
    y2: 7.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.5,
    y1: 7.5,
    x2: 7.5,
    y2: 17.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.5,
    y1: 40.48,
    x2: 30.63,
    y2: 40.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.5,
    y1: 40.48,
    x2: 40.5,
    y2: 30.61
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilSize);
export default __webpack_public_path__ + "static/media/pencil-size.4640113aeadb51803a6ce5f0c29c5b92.svg";
export { ForwardRef as ReactComponent };